import { GQLAvailablePromoServices } from 'generated-graphql/graphql'

export interface PromoServiceAvailableState {
  availablePromoServices: GQLAvailablePromoServices[] | null
}

export const initialState: PromoServiceAvailableState = {
  availablePromoServices: null,
}
